import request from '@/utils/request'


const getCodeApi = {

}

// 获取短信验证码
getCodeApi.validateLogin = mobile => {
  return request({
    url: '/sms/getVerificationCode/' + mobile + '?countryCode=86',
    method: 'get'
  })
}

// 通过短信验证码登录
getCodeApi.smsLogin = data => {
  return request({
    url: '/sms/login',
    method: 'post',
    data
  })
}

// 获取当前登录用户信息
getCodeApi.getCurUserInfo = data => {
  return request({
    url: '/sysUser/getCurUserInfo',
    method: 'post',
    headers: {
      'Content-Type': 'text/plain'
    },
    data
  })
}

// 同步销服用户信息
getCodeApi.getsyncCepUserInfo = data => {
  return request({
    url: '/sysUser/syncCepUserInfo',
    method: 'post',
    headers: {
      'Content-Type': 'text/plain'
    },
    data
  })
}


export default getCodeApi
